import axios from "axios";

import { GridTransactionExternal } from "types/transaction";
import {
  DataGridRequestParams,
  GridTransactionList,
} from "fe-shared-transactions/src/types";

import { PAGE_SIZE } from "consts";

export const getTransactions = (
  queryKey: string,
  requestParams: DataGridRequestParams,
  companyId: number,
  page: number | null = 1
) => {
  return axios
    .post<GridTransactionList<GridTransactionExternal>>(
      "getTransactions",
      {
        ...requestParams,
        ...(page !== null
          ? { limit: PAGE_SIZE, skip: PAGE_SIZE * (page - 1) }
          : {}),
      },
      { params: { companyId } }
    )
    .then((res) => res.data);
};

export default getTransactions;
